import { render, staticRenderFns } from "./dingd-shanghai.vue?vue&type=template&id=2dfc9b06&scoped=true"
import script from "./dingd-shanghai.vue?vue&type=script&lang=js"
export * from "./dingd-shanghai.vue?vue&type=script&lang=js"
import style0 from "./dingd-shanghai.vue?vue&type=style&index=0&id=2dfc9b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc9b06",
  null
  
)

export default component.exports